import {Component} from '@angular/core';

@Component({
    standalone: false,
    templateUrl: './dashboard-footer-layout.component.html',
})
export class DashboardFooterLayoutComponent {

}
